import { render, staticRenderFns } from "./Spokenlangs.vue?vue&type=template&id=96032892&"
import script from "./Spokenlangs.vue?vue&type=script&lang=js&"
export * from "./Spokenlangs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports